module.exports = __webpack_public_path__ + "static/img/classifyBanner1.b6d5f178.png";